import { getKeyValues } from '../services/config';

/**
 * Obtains an spotlight URL
 * @param {Object} cover Cover image.
 * @returns {string} URL of the image using spotlight.
 */
export function getUrl({ url, width, height }) {
  if (!url) {
    return;
  }
  const urlParams = new URLSearchParams();
  urlParams.append('image', url);
  width && urlParams.append('width', width);
  height && urlParams.append('height', height);

  return `${getKeyValues().spotlightUrl}?${urlParams.toString()}`;
}
